<!-- 报警原因Column -->
<template>
    <div>
        <div class="ex-connection-tag" v-if="row['alarmReason'] === 0">{{ $t('integration.abnormal_connection') }}</div>
        <div class="ex-data-tag" v-else-if="row['alarmReason'] === 1">{{ $t('integration.abnormal_data') }}</div>
        <div class="ex-power-tag" v-else-if="row['alarmReason'] === 2">{{ $t('integration.abnormal_power_failure') }}</div>
    </div>
</template>

<script>
export default {
    props: ['row'],
    data() {
        return {

        }
    }
}
</script>

